import api from './api';

export const skillsApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number }) => api.get('/skills/', { params }),
  get: (id: number) => api.get(`/skills/${id}`),
  create: (data: any) => api.post('/skills/', data),
  update: (id: number, data: any) => api.put(`/skills/${id}`, data),
  delete: (id: number) => api.delete(`/skills/${id}`),
  versions: (id: number) => api.get(`/skills/${id}/versions`),
  restore: (id: number, version: number) => api.post(`/skills/${id}/restore`, null, { params: { version } }),
};

export const toolsApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number }) => api.get('/tools/', { params }),
  get: (id: number) => api.get(`/tools/${id}`),
  create: (data: any) => api.post('/tools/', data),
  update: (id: number, data: any) => api.put(`/tools/${id}`, data),
  delete: (id: number) => api.delete(`/tools/${id}`),
};

export const mcpServersApi = {
  list: (params?: { skip?: number; limit?: number }) => api.get('/mcp-servers/', { params }),
  get: (id: number) => api.get(`/mcp-servers/${id}`),
  create: (data: any) => api.post('/mcp-servers/', data),
  update: (id: number, data: any) => api.put(`/mcp-servers/${id}`, data),
  delete: (id: number) => api.delete(`/mcp-servers/${id}`),
  test: (id: number) => api.post(`/mcp-servers/${id}/test`),
};

export const documentsApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number }) => api.get('/documents/', { params }),
  get: (id: number) => api.get(`/documents/${id}`),
  create: (data: any) => api.post('/documents/', data),
  update: (id: number, data: any) => api.put(`/documents/${id}`, data),
  delete: (id: number) => api.delete(`/documents/${id}`),
  upload: (formData: FormData) => api.post('/documents/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};

export const applicationsApi = {
  list: (params?: { skip?: number; limit?: number }) => api.get('/sub_app/', { params }),
  get: (id: number) => api.get(`/sub_app/${id}`),
  getBySlug: (slug: string) => api.get(`/sub_app/by-slug/${slug}`),
  create: (data: any) => api.post('/sub_app/', data),
  update: (id: number, data: any) => api.put(`/sub_app/${id}`, data),
  delete: (id: number) => api.delete(`/sub_app/${id}`),
  clone: (id: number) => api.post(`/sub_app/${id}/clone`),
  uploadStatic: (id: number, formData: FormData) => api.post(`/sub_app/${id}/upload-static`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180000,
  }),
  permissions: (id: number) => api.get(`/sub_app/${id}/permissions`),
  addPermission: (id: number, data: any) => api.post(`/sub_app/${id}/permissions`, data),
  removePermission: (appId: number, permId: number) => api.delete(`/sub_app/${appId}/permissions/${permId}`),
  listFiles: (id: number) => api.get(`/sub_app/${id}/files`),
  readFile: (id: number, path: string) => api.get(`/sub_app/${id}/files/content`, { params: { path }, transformResponse: [(data: string) => data] }) as any,
  writeFile: (id: number, path: string, content: string) => api.put(`/sub_app/${id}/files/content`, { path, content }),
  createFile: (id: number, path: string, type: 'file' | 'directory') => api.post(`/sub_app/${id}/files/create`, { path, type }),
  deleteFile: (id: number, path: string) => api.delete(`/sub_app/${id}/files`, { params: { path } }),
  uninstall: (id: number) => api.post(`/sub_app/${id}/uninstall`),
  getAgentNames: (id: number) => api.get(`/sub_app/${id}/agent-names`),
  getPluginSettings: (id: number) => api.get(`/sub_app/${id}/plugin-settings`),
  getPluginSettingsValues: (id: number) => api.get(`/sub_app/${id}/plugin-settings-values`),
  savePluginSettingsValues: (id: number, values: Record<string, any>) => api.put(`/sub_app/${id}/plugin-settings-values`, values),
};

export const employeesApi = {
  list: (params?: { skip?: number; limit?: number; application_id?: number }) => api.get('/digital-employees/', { params }),
  get: (id: number) => api.get(`/digital-employees/${id}`),
  create: (data: any) => api.post('/digital-employees/', data),
  update: (id: number, data: any) => api.put(`/digital-employees/${id}`, data),
  delete: (id: number) => api.delete(`/digital-employees/${id}`),

  updateDirectory: (id: number) => api.post(`/digital-employees/${id}/update`),
  updateSoul: (id: number, content: string) => api.put(`/digital-employees/${id}/soul`, { content }),
  listFiles: (id: number) => api.get(`/digital-employees/${id}/files`),
  readFile: (id: number, path: string) => api.get(`/digital-employees/${id}/files/content`, { params: { path }, transformResponse: [(data: string) => data] }) as any,
  writeFile: (id: number, path: string, content: string) => api.put(`/digital-employees/${id}/files/content`, { path, content }),
  createFile: (id: number, path: string, type: 'file' | 'directory') => api.post(`/digital-employees/${id}/files/create`, { path, type }),
  deleteFile: (id: number, path: string) => api.delete(`/digital-employees/${id}/files`, { params: { path } }),
  installedSkills: (id: number) => api.get(`/digital-employees/${id}/installed-skills`),
  upgradeResource: (id: number, type: string, resourceId: number) => api.post(`/digital-employees/${id}/upgrade-resource`, { type, id: resourceId }),
  checkUpdates: (id: number) => api.get(`/digital-employees/${id}/check-updates`),
  getCommandAllowlist: (id: number) => api.get(`/digital-employees/${id}/command-allowlist`),
  updateCommandAllowlist: (id: number, allowlist: string[]) => api.put(`/digital-employees/${id}/command-allowlist`, { command_allowlist: allowlist }),
  listPermissionRequests: (id: number) => api.get(`/digital-employees/${id}/permission-requests`),
  approvePermissionRequest: (empId: number, reqId: number) => api.post(`/digital-employees/${empId}/permission-requests/${reqId}/approve`),
  denyPermissionRequest: (empId: number, reqId: number) => api.post(`/digital-employees/${empId}/permission-requests/${reqId}/deny`),
  revokePermissionRequest: (empId: number, reqId: number) => api.post(`/digital-employees/${empId}/permission-requests/${reqId}/revoke`),
  deletePermissionRequests: (empId: number, ids: number[]) => api.delete(`/digital-employees/${empId}/permission-requests`, { data: ids }),
};

export const gatewayApi = {
  list: (empId: number) => api.get(`/digital-employees/${empId}/gateways`),
  platformsMeta: () => api.get('/digital-employees/platforms/meta'),
  bind: (empId: number, data: { platform: string; credentials: Record<string, string>; config?: Record<string, any> }) =>
    api.post(`/digital-employees/${empId}/gateways/bind`, data),
  sync: (empId: number, bindingId: number) =>
    api.post(`/digital-employees/${empId}/gateways/${bindingId}/sync`),
  feishuQrBegin: (empId: number, domain = 'feishu') =>
    api.post(`/digital-employees/${empId}/gateways/feishu/qr/begin`, { domain }),
  feishuQrPoll: (empId: number, device_code: string, domain = 'feishu') =>
    api.post(`/digital-employees/${empId}/gateways/feishu/qr/poll`, { device_code, domain }),
  feishuManual: (empId: number, data: { app_id: string; app_secret: string; domain?: string }) =>
    api.post(`/digital-employees/${empId}/gateways/feishu/manual`, data),
  weixinQrBegin: (empId: number) =>
    api.post(`/digital-employees/${empId}/gateways/weixin/qr/begin`, {}),
  weixinQrPoll: (empId: number, qrcode: string, base_url: string) =>
    api.post(`/digital-employees/${empId}/gateways/weixin/qr/poll`, { qrcode, base_url }),
  dingtalkQrBegin: (empId: number) =>
    api.post(`/digital-employees/${empId}/gateways/dingtalk/qr/begin`, {}),
  dingtalkQrPoll: (empId: number, device_code: string) =>
    api.post(`/digital-employees/${empId}/gateways/dingtalk/qr/poll`, { device_code }),
  dingtalkManual: (empId: number, data: { app_id: string; app_secret: string }) =>
    api.post(`/digital-employees/${empId}/gateways/dingtalk/manual`, data),
  updateConfig: (empId: number, bindingId: number, data: Record<string, any>) =>
    api.put(`/digital-employees/${empId}/gateways/${bindingId}`, data),
  reinstall: (empId: number, bindingId: number) =>
    api.post(`/digital-employees/${empId}/gateways/${bindingId}/reinstall`),
  start: (empId: number, bindingId: number) =>
    api.post(`/digital-employees/${empId}/gateways/${bindingId}/start`),
  remove: (empId: number, bindingId: number) =>
    api.delete(`/digital-employees/${empId}/gateways/${bindingId}`),
};

export const expertsApi = {
  list: (params?: { skip?: number; limit?: number }) => api.get('/experts/', { params }),
  get: (id: number) => api.get(`/experts/${id}`),
  create: (data: any) => api.post('/experts/', data),
  update: (id: number, data: any) => api.put(`/experts/${id}`, data),
  delete: (id: number) => api.delete(`/experts/${id}`),
};

export const notificationsApi = {
  list: (params?: { skip?: number; limit?: number; unread_only?: boolean }) => api.get('/notifications/', { params }),
  getUnreadCount: () => api.get('/notifications/unread-count'),
  markAsRead: (id: number) => api.put(`/notifications/${id}/read`),
  markAllAsRead: () => api.put('/notifications/read-all'),
  delete: (id: number) => api.delete(`/notifications/${id}`),
};

export const ticketsApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number; status_filter?: string }) => api.get('/tickets/', { params }),
  get: (id: number) => api.get(`/tickets/${id}`),
  create: (data: any) => api.post('/tickets/', data),
  update: (id: number, data: any) => api.put(`/tickets/${id}`, data),
  delete: (id: number) => api.delete(`/tickets/${id}`),
  evaluate: (id: number, evaluation: string) => api.post(`/tickets/${id}/evaluate`, null, { params: { evaluation } }),
  cancel: (id: number) => api.post(`/tickets/${id}/cancel`),
};

export const productsApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number; application_id?: number; product_type?: string }) => api.get('/products/', { params }),
  get: (id: number) => api.get(`/products/${id}`),
  create: (data: any) => api.post('/products/', data),
  update: (id: number, data: any) => api.put(`/products/${id}`, data),
  uploadFile: (formData: FormData) => api.post('/products/upload-file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id: number) => api.delete(`/products/${id}`),
  download: (id: number) => api.get(`/products/${id}/download`, { responseType: 'blob' }),
};

export const dictionariesApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number }) => api.get('/dictionaries/', { params }),
  get: (id: number) => api.get(`/dictionaries/${id}`),
  getByCode: (code: string) => api.get(`/dictionaries/code/${code}`),
  create: (data: any) => api.post('/dictionaries/', data),
  update: (id: number, data: any) => api.put(`/dictionaries/${id}`, data),
  delete: (id: number) => api.delete(`/dictionaries/${id}`),
};

export const usersApi = {
  list: (params?: { skip?: number; limit?: number; page?: number; page_size?: number; is_expert?: boolean }) => api.get('/users/', { params }),
  listExperts: () => api.get('/users/', { params: { is_expert: true } }),
  create: (data: any) => api.post('/users/', data),
  update: (id: number, data: any) => api.put(`/users/${id}`, data),
  delete: (id: number) => api.delete(`/users/${id}`),
  updateMe: (data: { avatar?: string }) => api.put('/me', data),
};

export const chatApi = {
  matchEmployee: (data: { message: string; application_id?: number }) => api.post('/chat/match-employee', data),
  listEmployees: (params?: { application_id?: number }) => api.get('/chat/employees', { params }),
  warmup: (employeeId: number) => api.post(`/chat/warmup/${employeeId}`),
  listSessions: (params?: { employee_id?: number }) => api.get('/chat/sessions', { params }),
  getSessionMessages: (sessionId: string) => api.get(`/chat/sessions/${sessionId}/messages`),
  deleteSession: (sessionId: string) => api.delete(`/chat/sessions/${sessionId}`),
  clearSessionContext: (sessionId: string) => api.post(`/chat/sessions/${sessionId}/clear`),
  deleteAllSessions: (employeeId?: number) => api.post('/chat/sessions/clear', null, { params: employeeId ? { employee_id: employeeId } : undefined }),
  saveSession: (sessionId: string, savedName: string) => api.post('/chat/sessions/save', { session_id: sessionId, saved_name: savedName }),
  listSavedSessions: () => api.get('/chat/sessions/saved'),
  uploadFile: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/chat/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  getWsUrl: (token: string) => {
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    let apiHost: string;
    if (process.env.REACT_APP_API_URL) {
      apiHost = process.env.REACT_APP_API_URL.replace(/^https?:\/\//, '').replace(/\/api\/v1$/, '');
    } else if (process.env.NODE_ENV === 'development') {
      apiHost = window.location.hostname + ':8000';
    } else {
      apiHost = window.location.host;
    }
    return `${wsProtocol}//${apiHost}/api/v1/chat/ws?token=${token}`;
  },
};

export const uploadApi = {
  image: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/upload/image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const agentConfigApi = {
  getHermesEnv: () => api.get('/agent-config/hermes/env'),
  updateHermesEnv: (items: { key: string; value: string }[]) => api.put('/agent-config/hermes/env', { items }),
  getHermesConfig: () => api.get('/agent-config/hermes/config'),
  updateHermesConfig: (content: string) => api.put('/agent-config/hermes/config', { content }),
  getClaudeSettings: () => api.get('/agent-config/claude-code/settings'),
  updateClaudeSettings: (content: string) => api.put('/agent-config/claude-code/settings', { content }),
  getAgentConfig: (agentId: string) => api.get(`/agent-config/agents/${agentId}/config`),
  previewAgentConfig: (agentId: string, profile: string) => api.get(`/agent-config/agents/${agentId}/config/preview`, { params: { profile } }),
  saveAgentConfig: (agentId: string, items: { key: string; value: string }[], profile?: string) => api.put(`/agent-config/agents/${agentId}/config`, { items, profile }),
  // 大模型配置（model_provider + system_base 聚合）
  getGlobalConfig: () => api.get('/agent-config/global'),
  updateGlobalConfig: (config: Record<string, any>) => api.put('/system-configs/model_provider', { config }),
  applyGlobalProfile: (name: string) => api.post('/agent-config/global/apply', { name }),
  testGlobalProfile: (name: string) => api.post('/agent-config/global/test', { name }),
  applyProfileToEmployee: (employeeId: number, profile: string, model?: string) => api.post(`/agent-config/employee/${employeeId}/apply-profile`, { profile, model }),
  getEmployeeConfig: (employeeId: number) => api.get(`/agent-config/employee/${employeeId}/config`),
};

export const systemConfigApi = {
  // 基础配置（system_base）- 从数据库读取
  getConfig: () => api.get('/system-configs/system_base').then((res: any) => res.config || {}),
  updateConfig: (config: Record<string, any>) => api.put('/system-configs/system_base', { config }),
  // 获取所有配置的聚合视图
  getAllConfigs: () => api.get('/system-configs'),
  // 环境变量配置（env_vars）
  getEnvVars: () => api.get('/system-configs/env_vars').then((res: any) => (res.config?.vars || [])),
  updateEnvVars: (vars: { key: string; value: string }[]) =>
    api.put('/system-configs/env_vars', { config: { vars } }),
};

export const pluginApi = {
  list: () => api.get('/plugins'),
  get: (name: string) => api.get(`/plugins/${name}`),
  start: (name: string) => api.post(`/plugins/${name}/start`),
  stop: (name: string) => api.post(`/plugins/${name}/stop`),
  logs: (name: string) => api.get(`/plugins/${name}/logs`),
  clearLogs: (name: string) => api.delete(`/plugins/${name}/logs`),
  getConfigFile: (name: string) => api.get(`/plugins/${name}/config`),
  saveConfigFile: (name: string, globalConfig: any) => api.put(`/plugins/${name}/config`, { global_config: globalConfig }),
  add: (data: any) => api.post('/plugins', data),
  delete: (name: string) => api.delete(`/plugins/${name}`),
  builtins: () => api.get('/plugins/builtins'),
};

export const rolePermissionsApi = {
  list: () => api.get('/role-permissions/'),
  meta: () => api.get('/role-permissions/meta'),
  my: () => api.get('/role-permissions/my'),
  get: (role: string) => api.get(`/role-permissions/${role}`),
  update: (role: string, permissions: { menus: string[]; actions: string[] }) =>
    api.put(`/role-permissions/${role}`, { permissions }),
};

export const featureConfigsApi = {
  list: () => api.get('/feature-configs/'),
  get: (id: number) => api.get(`/feature-configs/${id}`),
  create: (data: any) => api.post('/feature-configs/', data),
  update: (id: number, data: any) => api.put(`/feature-configs/${id}`, data),
  delete: (id: number) => api.delete(`/feature-configs/${id}`),
};

export const helpConfigsApi = {
  list: () => api.get('/help-configs/'),
  get: (id: number) => api.get(`/help-configs/${id}`),
  create: (data: any) => api.post('/help-configs/', data),
  update: (id: number, data: any) => api.put(`/help-configs/${id}`, data),
  delete: (id: number) => api.delete(`/help-configs/${id}`),
};

export const agentTasksApi = {
  list: (params?: { status?: string; employee_id?: number; skip?: number; limit?: number; page?: number; page_size?: number }) =>
    api.get('/agent-tasks/', { params }),
  get: (taskId: string) => api.get(`/agent-tasks/${taskId}`),
  getRuns: (taskId: string) => api.get(`/agent-tasks/${taskId}/runs`),
  create: (data: any) => api.post('/agent-tasks/', data),
  update: (taskId: string, data: any) => api.put(`/agent-tasks/${taskId}`, data),
  run: (taskId: string) => api.post(`/agent-tasks/${taskId}/run`),
  cancel: (taskId: string) => api.post(`/agent-tasks/${taskId}/cancel`),
  delete: (taskId: string) => api.delete(`/agent-tasks/${taskId}`),
};
